var local_storage_with_expire = {
	save: function (key, jsonData, expirationMin) {
		var expirationMS = expirationMin * 60 * 1000;
		var record = {value: JSON.stringify(jsonData), timestamp: new Date().getTime() + expirationMS};
		localStorage.setItem(key, JSON.stringify(record));
		console.log('saving to local storage');
		return jsonData;
	},
	load: function (key) {
		var record = JSON.parse(localStorage.getItem(key));
		if (!record) {
			return false;
		}
		return (new Date().getTime() < record.timestamp && JSON.parse(record.value));
	}
};
// 4320 minutes in 3 days
// local_storage_with_expire.save('liberal-exit-modal', storage_val, 4320);
// var has_seen_modal = local_storage_with_expire.load('liberal-exit-modal');


function getAllUrlParams(url) {

	// get query string from url (optional) or window
	var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

	// we'll store the parameters here
	var obj = {};

	// if query string exists
	if (queryString) {

		// stuff after # is not part of query string, so get rid of it
		queryString = queryString.split('#')[0];

		// split our query string into its component parts
		var arr = queryString.split('&');

		for (var i = 0; i < arr.length; i++) {
			// separate the keys and the values
			var a = arr[i].split('=');

			// set parameter name and value (use 'true' if empty)
			var paramName = a[0];
			var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

			// (optional) keep case consistent
			paramName = paramName.toLowerCase();
			if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

			// if the paramName ends with square brackets, e.g. colors[] or colors[2]
			if (paramName.match(/\[(\d+)?\]$/)) {

				// create key if it doesn't exist
				var key = paramName.replace(/\[(\d+)?\]/, '');
				if (!obj[key]) obj[key] = [];

				// if it's an indexed array e.g. colors[2]
				if (paramName.match(/\[\d+\]$/)) {
					// get the index value and add the entry at the appropriate position
					var index = /\[(\d+)\]/.exec(paramName)[1];
					obj[key][index] = paramValue;
				} else {
					// otherwise add the value to the end of the array
					obj[key].push(paramValue);
				}
			} else {
				// we're dealing with a string
				if (!obj[paramName]) {
					// if it doesn't exist, create property
					obj[paramName] = paramValue;
				} else if (obj[paramName] && typeof obj[paramName] === 'string') {
					// if property does exist and it's a string, convert it to an array
					obj[paramName] = [obj[paramName]];
					obj[paramName].push(paramValue);
				} else {
					// otherwise add the property
					obj[paramName].push(paramValue);
				}
			}
		}
	}

	return obj;
}

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function eraseCookie(name) {
	document.cookie = name + '=; Max-Age=-99999999;';
}

(function ($) {

	$(document).ready(function () {

		/**
		 * Add 'document-ready' class to body for various CSS selector needs
		 */
		$('body').addClass('document-ready');

		$('.reveal').on('open.zf.reveal', function(e){
			$(this).find('img[data-modal-image-src]').each(function( index ) {
				$(this).attr('src', $(this).data('modal-image-src'));
				console.log('loading ' + $(this).data('modal-image-src'));
			});
		});
	});
	$(window).load(function() {
		$('body').addClass('window-loaded');
	});
}(jQuery));


var storage = {
	save: function (key, jsonData, expirationMin) {
		var expirationMS = expirationMin * 60 * 1000;
		var record = {value: JSON.stringify(jsonData), timestamp: new Date().getTime() + expirationMS};
		localStorage.setItem(key, JSON.stringify(record));
		return jsonData;
	},
	load: function (key) {
		var record = JSON.parse(localStorage.getItem(key));
		if (!record) {
			return false;
		}
		return (new Date().getTime() < record.timestamp && JSON.parse(record.value));
	}
};

(function ($) {



	var setEqualHeight = function (selector) {
		var max_height = 0;
		if ($(window).width() > 640) {
			$(selector).height('auto');
			$(selector).each(function (index, value) {
				if ($(this).height() > max_height) {
					max_height = $(this).height();
				}
			});
			$(selector).height(max_height);
		} else {
			$(selector).height('auto');
		}

	};
	var initEqualHeightSizing = function () {
		if ($('body').hasClass('home') || $('body').hasClass('page-template-front-page-new')) {
			$(window).resize(function () {
				setEqualHeight('#home-section--take-action .post-listing-item h3');
				setEqualHeight('#home-section--watch .post-listing-item h3');
				setEqualHeight('#home-section--read .post-listing-item h3');

				setEqualHeight('#home-section--take-action .post-listing-item .post-listing-item__excerpt');
				setEqualHeight('#home-section--watch .post-listing-item .post-listing-item__excerpt');
				setEqualHeight('#home-section--read .post-listing-item .post-listing-item__excerpt');

				setEqualHeight('.donate-hero-bottom .donate-hero-bottom__excerpt');
			});
			$(window).trigger('resize');
		}
	};

	var fixSafariChildFlex = function () {
		var user_agent = navigator.userAgent;
		if (user_agent.indexOf("Safari") > -1 && user_agent.indexOf("Chrome") == -1) {
			var last_index_of_delimiter = user_agent.lastIndexOf("/");
			var version = user_agent.substring(last_index_of_delimiter + 1);
			var major_version = version.substr(0, version.indexOf('.'));
			if (parseInt(major_version) < 604) {
				$('.post-listing-item__link').css('display', 'block');
			}

		}

	};


	var sizeNewWindow = function (link, w, h) {
		// Fixes dual-screen position                         Most browsers      Firefox
		var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
		var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		var left = ((width / 2) - (w / 2)) + dualScreenLeft;
		var top = ((height / 2) - (h / 2)) + dualScreenTop;
		window.open(link, '_blank', 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	};

	var registerSocialShareLinkOpen = function () {
		jQuery('a.size-new-window').on('click', function (e) {
			e.preventDefault();

			var $this = $(this);
			if (!$this.hasClass('disabled')) {
				sizeNewWindow($this.attr('href'), 600, 350);
			}

		});
	};
	jQuery(document).ready(function () {
		registerSocialShareLinkOpen();
	});

	/*====================================================
	=            New Video Wrapper Show Video            =
	====================================================*/

	jQuery(document).ready(function () {

		jQuery('.post-listing-item__iframe-video-wrapper').on('click keypress', function (e) {
			if (e.type == "keypress" && e.keyCode != 13) {
				return;
			}

			var $target = jQuery(this);
			var $iframe = $target.find('iframe');
			$iframe.attr('src', $iframe.data('iframe-src'));
			$iframe.addClass('displayed');
			$iframe.removeAttr('hidden');
			$target.attr('tabindex', '-1');
		})


	});

	/*=====  End of New Video Wrapper Show Video  ======*/

	/*=============================================
	=            IFRAME PARAMETER PASS            =
	=============================================*/

	var passParametersToIframeSrc = function () {
		jQuery('iframe.pull-parameters-from-parent').each(function (e) {
			var registration_iframe_url = window.location.href;
			var url_split = registration_iframe_url.split("?");
			var iframe_src = jQuery(this).attr('src');
			if (typeof url_split[1] !== 'undefined') {
				iframe_src = iframe_src + '?' + url_split[1];
			}
			jQuery(this).attr('src', iframe_src);
		});

	};

	jQuery(document).ready(function () {
		passParametersToIframeSrc();

	});


	/*=====  End of IFRAME PARAMETER PASS  ======*/

	/**
	 * Apply HTML5 pattern restriction to first name and last name generic gravity form fields
	 */

	var applyGFInputPattern = function () {
		jQuery('.gfield.input--first-name input').attr('pattern', "[a-zA-ZÀ-ž-'’.\\s]+");
		jQuery('.gfield.input--last-name input').attr('pattern', "[a-zA-ZÀ-ž-'’.\\s]+");
	};

	jQuery(document).ready(function () {
		applyGFInputPattern();
	});

}(jQuery));
